import { useFocusEffect } from '@react-navigation/native'
import { useCallback, useRef } from 'react'
import { BackHandler } from 'react-native'

export const useOpenTabModalBack = (
    onClose: () => void,
    { active = true, disabled = false }: { active?: boolean; disabled?: boolean } = {}
) => {
    const closeRef = useRef(onClose)
    closeRef.current = onClose
    const disabledRef = useRef(disabled)
    disabledRef.current = disabled

    useFocusEffect(
        useCallback(() => {
            if (!active) return

            const subscription = BackHandler.addEventListener('hardwareBackPress', () => {
                if (!disabledRef.current) closeRef.current()
                return true
            })
            return () => subscription.remove()
        }, [active])
    )
}
